import { render } from "./OutputListCom.vue?vue&type=template&id=b2497bf4&scoped=true"
import script from "./OutputListCom.vue?vue&type=script&lang=js"
export * from "./OutputListCom.vue?vue&type=script&lang=js"

import "./OutputListCom.vue?vue&type=style&index=0&id=b2497bf4&lang=less&scoped=true"
import "./OutputListCom.vue?vue&type=style&index=1&id=b2497bf4&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2497bf4"]])

export default __exports__